import {createClient} from '@supabase/supabase-js';

import {SUPABASE_ANON_KEY, SUPABASE_URL} from '../config';

const getAccessToken = () => typeof localStorage === 'undefined' ? null : localStorage.getItem('accessToken');

export const realtimeClient = createClient(SUPABASE_URL, SUPABASE_ANON_KEY, {
  accessToken: async () => getAccessToken(),
  auth: {persistSession: false},
});

const subscriptions = new Map();

function createSubscription(workspaceId, userId) {
  let resolveReady;
  const entry = {
    listeners: new Set(),
    statuses: [null, null],
    everReady: false,
    reconnecting: false,
    ready: new Promise((resolve) => { resolveReady = resolve; }),
  };

  const receive = ({payload}) => {
    entry.listeners.forEach(({onEvent}) => onEvent(payload));
  };
  const updateStatus = (index, status) => {
    entry.statuses[index] = status;
    if (status !== 'SUBSCRIBED') {
      if (entry.everReady) entry.reconnecting = true;
      return;
    }
    if (!entry.statuses.every((current) => current === 'SUBSCRIBED')) return;
    if (!entry.everReady) {
      entry.everReady = true;
      resolveReady();
    } else if (entry.reconnecting) {
      entry.reconnecting = false;
      entry.listeners.forEach(({onReconnect}) => onReconnect?.());
    }
  };

  entry.channels = [
    `workspace:${workspaceId}`,
    `workspace:${workspaceId}:user:${userId}`,
  ].map((topic, index) => realtimeClient
    .channel(topic, {config: {private: true}})
    .on('broadcast', {event: '*'}, receive)
    .subscribe((status) => updateStatus(index, status)));
  return entry;
}

export function subscribeWorkspaceEvents({workspaceId, userId, onEvent, onReconnect}) {
  const key = `${workspaceId}:${userId}`;
  const entry = subscriptions.get(key) || createSubscription(workspaceId, userId);
  const listener = {onEvent, onReconnect};
  subscriptions.set(key, entry);
  entry.listeners.add(listener);

  return {
    ready: entry.ready,
    unsubscribe() {
      entry.listeners.delete(listener);
      if (entry.listeners.size) return;
      subscriptions.delete(key);
      entry.channels.forEach((channel) => realtimeClient.removeChannel(channel));
    },
  };
}
